import { render, staticRenderFns } from "./UpsertCertificationInfo.vue?vue&type=template&id=2ee24d91&scoped=true&"
import script from "./UpsertCertificationInfo.vue?vue&type=script&lang=ts&"
export * from "./UpsertCertificationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UpsertCertificationInfo.vue?vue&type=style&index=0&id=2ee24d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee24d91",
  null
  
)

export default component.exports